import {createApp} from 'vue'
import App from './App.vue'
import Login from './Login.vue'
import axios from 'ts-axios-new'
import {createRouter, createWebHashHistory} from 'vue-router';
import {ElMessage} from "element-plus";
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {update} from './libs/utils'
import {getLocalObj, setLocalObj} from "./libs/storage";
import {routes} from './routes';

const router = createRouter({
    history: createWebHashHistory(),
    routes
});


let login: any = null;
declare var google: any;
let googleInitialized = false;

const root_props = {
    // user info
    user: {
        user_id: '',
        avatar: '',
        name: '',
        email: '',
    },
    user_list: [],
    authorization: '',
};

function ensureLoginContainer() {
    let el = document.getElementById('login');
    if (!el) {
        el = document.createElement('div');
        el.id = 'login';
        document.body.appendChild(el);
    }
    return el;
}

function initGoogleLogin() {
    if (!googleInitialized) {
        google.accounts.id.initialize({
            client_id: import.meta.env.VITE_OAUTH2_CLIENT_ID,
            callback: (response: any) => {
                axios.post('/cms/v1/oauth2/login', {
                    platform: 'google',
                    id_token: response.credential
                }).then(res => {
                    update(root_props.user, res.data.data);
                    setLocalObj('authorization', res.data.data.access_token);
                    root_props.authorization = res.data.data.access_token;
                    // 统一请求拦截，从存储中读取最新 token
                    axios.interceptors.request.use(function (config) {
                        const token = getLocalObj('authorization', '') || root_props.authorization;
                        if (token) config.headers['Authorization'] = token;
                        return config
                    }, function (error) {
                        return Promise.reject(error);
                    })
                    if (login) {
                        login.unmount();
                        login = null;
                    }
                    init();
                }).catch(_ => {
                    google.accounts.id.prompt((notification: any) => {
                        if (notification.isDisplayMoment() && notification.isNotDisplayed()) {
                            ensureLoginContainer();
                            login = createApp(Login);
                            login.mount('#login');
                        }
                    });
                })
            },
            auto_select: true,
        });
        googleInitialized = true;
    }
    google.accounts.id.prompt((notification: any) => {
        if (notification.isDisplayMoment() && notification.isNotDisplayed()) {
            ensureLoginContainer();
            login = createApp(Login);
            login.mount('#login');
        }
    });
}

function init() {
    const app = createApp(App);
    app.use(router);
    app.use(ElementPlus, {locale: zhCn});
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }
    const vm = app.mount('#app');
    root_props.authorization = getLocalObj('authorization', '');
    update(vm, root_props);
}

window.onload = function () {
    const authorization = getLocalObj('authorization', null);
    axios.get('/cms/v1/me', {headers: {authorization}}).then(res => {
        update(root_props.user, res.data.data);
        axios.interceptors.request.use(function (config) {
            const token = getLocalObj('authorization', '') || root_props.authorization;
            if (token) config.headers['Authorization'] = token;
            return config
        }, function (error) {
            return Promise.reject(error);
        })
        // 全局响应拦截：token 过期触发重新登录
        axios.interceptors.response.use(function (response) { return response; }, function (error) {
            const status = error?.response?.status;
            if (status === 401) {
                setLocalObj('authorization', '');
                root_props.authorization = '';
                ElMessage.error('登录已过期，尝试重新登录中。若还是失败，请尝试刷新页面');
                initGoogleLogin();
            }
            return Promise.reject(error);
        });
        init();
    }).catch(_ => {
        initGoogleLogin();
    })
}
